import React, {useRef, useState, useContext} from 'react';
import { Card, Button, Form, Container, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContext } from '../context/AuthContext';
import { Link, useHistory } from 'react-router-dom';


const Signup = () => {
    
    
    const emailRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();
    const { signup, currentUser } = useContext(AuthContext);
    const value = useContext(AuthContext);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    async function handleSubmit (e){
        e.preventDefault();
        if(passwordRef.current.value !== passwordConfirmRef.current.value){
            return setError("passwords donot match");
        }
       

        try{
            console.log({signup});
            setError("");
            await signup(emailRef.current.value, passwordRef.current.value);
            history.push("/");
        }catch(error){
            setError(error.message);
        }
            
        
        
    }

    return ( 
        <>
        <Container className="d-flex align-items-center justify-content-center" style={{minHeight:"100vh"}}>
        <div className="w-100" style={{ minHeight:"400px" }}>
        {/* {currentUser.email} */}
        <Card>
            <Card.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <h4 className="text-center mb-4">SignUp</h4>
                <Form onSubmit={handleSubmit}>
                    <Form.Group id="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" ref = {emailRef} required/>
                    </Form.Group>
                    <Form.Group id="password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" ref = {passwordRef} required/>
                    </Form.Group>
                    <Form.Group id="passwordConfirm">
                        <Form.Label>Password Confirmation</Form.Label>
                        <Form.Control type="password" ref = {passwordConfirmRef} required/>
                    </Form.Group>
                    <Button className="w-100 mt-4" type="submit" disabled={loading}>Signup</Button>
                </Form>        
            </Card.Body>
        </Card>
        <Link to="/login">
            <div className="w-100 text-center mt-2">
                Already have an account? Login
            </div>
        </Link>
        </div>
        </Container>
        </>
     );
}
 
export default Signup;